import React, {useEffect, useContext, useState} from 'react';
import {useTranslation} from "react-i18next";
import {Link, useHistory, useParams} from "react-router-dom";
import useMediaQuery from '@mui/material/useMediaQuery';
import {createTheme, ThemeProvider} from '@mui/material/styles';
import {makeStyles} from '@mui/styles';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import Divider from '@mui/material/Divider';
import Paper from '@mui/material/Paper';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import SaveIcon from '@mui/icons-material/Save';
import DeleteIcon from '@mui/icons-material/Delete';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import Grid from '@mui/material/Grid';
import jwt_decode from "jwt-decode";
import liff from "@line/liff";
import {httpClient} from '../../core/HttpClient'
import {Context} from "../../core/Context";

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    link: {
        color: theme.palette.primary.main,
        textDecoration: 'none'
    },
    large: {
        width: theme.spacing(9),
        height: theme.spacing(9),
    },
    actionControl: {
        marginTop: '1rem'
    },
    paper: {
        marginBottom: '10px'
    },
    boxLeft: {
        padding: theme.spacing(1),
        textAlign: 'left'
    },
    boxRight: {
        padding: theme.spacing(1),
        textAlign: 'right'
    },
    itemSave: {
        order: 1,
        [theme.breakpoints.up('sm')]: {
            order: 2,
        },
    },
    itemCancel: {
        order: 2,
        [theme.breakpoints.up('sm')]: {
            order: 1,
        },
    }
}));

const theme = createTheme({
    palette: {
        primary: {
            main: '#00B300',
            dark: '#00C900',
            contrastText: '#ffffff',
        },
    },
});


let ROLE = '';
let KEY = '';
let ACCOUNT_NAME = null;
let INVITE_URL = '';
let IMAGE_URL = `${process.env.REACT_APP_CDN_BASE_URL}/public/assets/empty.png`;

export default function User() {
    const {t} = useTranslation();
    const classes = useStyles();
    const history = useHistory();
    const matches = useMediaQuery(theme.breakpoints.down('sm'));
    const {id} = useParams();
    const [context, setContext] = useContext(Context);
    const [open, setOpen] = React.useState(false);
    const [loading, setLoading] = useState({init: true, update: false});
    const [user, setUser] = useState({
        _id: '',
        displayName: '',
        pictureUrl: '',
        role: 'STAFF'
    });

    useEffect(() => {
        console.log('[User]');
        if (id) {
            const url = process.env.REACT_APP_API_BASE_URL + '/users/' + id;
            httpClient.get(url)
                .then(res => {
                    if (res.data) {
                        let ca = {roles: []};
                        const token = localStorage.getItem('token');
                        if (token) {
                            var decoded = jwt_decode(token);
                            if (decoded.account) {
                                let tmp = res.data.accounts.filter(obj => {
                                    return obj.account === decoded.account
                                });
                                if(tmp[0]){
                                    ca = tmp[0];
                                }
                            }
                        }

                        setUser({
                            _id: res.data._id,
                            displayName: res.data.displayName,
                            role: ca.roles[0],
                        });
                    }
                    setLoading({init: false, update: false});
                });
        } else {
            const url = process.env.REACT_APP_API_BASE_URL + '/accounts/users/invite';
            setLoading({init: false, update: true});
            httpClient.post(url, {role: 'STAFF'})
                .then(res => {
                    let result = res.data;
                    if(result && result.data && result.data.account && result.key) {
                        let account = result.data.account;
                        ROLE = result.data.role;
                        ACCOUNT_NAME = account.name.i18n['th'] || account.name.i18n['en'];
                        if (account.image) {
                            IMAGE_URL = `${process.env.REACT_APP_CDN_BASE_URL}/${account.image.permission}/merchant/s/${account.image.name}`;
                        }

                        KEY = result.key;
                        const liffId = process.env.REACT_APP_LINE_SIGNIN_LIFF_ID;
                        INVITE_URL = `https://liff.line.me/${liffId}/user/invite/${KEY}`;

                    }
                    setLoading({init: false, update: false});
                });
        }
    }, [id]);

    const handleChangeInviteTicket = ({ target }) => {
        setUser({ ...user, [target.name]: target.value });
        const url = process.env.REACT_APP_API_BASE_URL + '/accounts/users/invite';
        setLoading({init: false, update: true});
        httpClient.post(url, {role: target.value})
            .then(res => {
                let result = res.data;
                if(result && result.data && result.data.account && result.key) {
                    let account = result.data.account;
                    ROLE = result.data.role;
                    ACCOUNT_NAME = account.name.i18n['th'] || account.name.i18n['en'];
                    if (account.image) {
                        IMAGE_URL = `${process.env.REACT_APP_CDN_BASE_URL}/${account.image.permission}/merchant/o/${account.image.name}`;
                    }

                    KEY = result.key;
                    const liffId = process.env.REACT_APP_LINE_SIGNIN_LIFF_ID;
                    INVITE_URL = `https://liff.line.me/${liffId}/user/invite/${KEY}`;

                }
                setLoading({init: false, update: false});
            });
    };

    const handleChange = ({ target }) => {
        setUser({ ...user, [target.name]: target.value });
    };

    const handleSave = () => {
        console.log('handleSave');
        const url = process.env.REACT_APP_API_BASE_URL + '/users/' + user._id + '/role';
        httpClient.put(url, {...user})
            .then(res => {
                if (res.data) {
                    setContext({ ...context, success: true});
                    history.push('/users');
                }
            });
    };

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleDelete = () => {
        setLoading({init: false, update: true});
        const id = user._id;
        const url = process.env.REACT_APP_API_BASE_URL + '/users/' + id;
        httpClient.delete(url)
            .then(res => {
                setContext({ ...context, success: true});
                setLoading({init: false, update: false});
                history.push('/users');
            });
    };

    const handleSendInvite = async() => {
        const liffId = process.env.REACT_APP_LINE_SIGNIN_LIFF_ID;
        await liff.init({ liffId: liffId, withLoginOnExternalBrowser: true }).catch(err=>{});
        if (liff.isLoggedIn()) {
            if (liff.isApiAvailable('shareTargetPicker')) {
                liff.shareTargetPicker([
                    {
                        "type": "flex",
                        "altText": "Flex Message",
                        "contents": {
                            "type": "bubble",
                            "hero": {
                                "type": "image",
                                "url": IMAGE_URL,
                                "size": "full",
                                "aspectRatio": "20:13",
                                "aspectMode": "fit",
                                "action": {
                                    "type": "uri",
                                    "uri": INVITE_URL
                                }
                            },
                            "body": {
                                "type": "box",
                                "layout": "vertical",
                                "contents": [
                                    {
                                        "type": "text",
                                        "text": ACCOUNT_NAME,
                                        "weight": "bold",
                                        "size": "xl"
                                    },
                                    {
                                        "type": "text",
                                        "text": t(`user.roles.${ROLE}`),
                                        "wrap": true,
                                        "color": "#666666",
                                        "size": "sm",
                                        "flex": 5
                                    }
                                ]
                            },
                            "footer": {
                                "type": "box",
                                "layout": "vertical",
                                "spacing": "sm",
                                "contents": [
                                    {
                                        "type": "button",
                                        "style": "link",
                                        "height": "sm",
                                        "action": {
                                            "type": "uri",
                                            "label": "ยอมรับคำเชิญ",
                                            "uri": INVITE_URL
                                        }
                                    },
                                    {
                                        "type": "spacer",
                                        "size": "sm"
                                    }
                                ],
                                "flex": 0
                            }
                        }
                    }
                ]).catch(e => {
                    console.log('error', e);
                    _sendNormalText();
                });
            } else{
                console.log('Api shareTargetPicker Not Available');
                _sendNormalText();
            }

            function _sendNormalText() {
                const shareFriendUrl = 'https://line.me/R/msg/text/?' + INVITE_URL;
                window.open(shareFriendUrl, '_blank');
            }

        } else {
            liff.login();
        }

    };

    return (
        <div>
            <form className={classes.root} noValidate autoComplete="off">
                <Box m={1}>
                    <Breadcrumbs aria-label="breadcrumb">
                        <Link to="/users" className={classes.link}>
                            <Typography variant="h6">
                                {t('user.title')}
                            </Typography>
                        </Link>
                    </Breadcrumbs>
                </Box>
                <Divider style={{'marginBottom': '10px', 'marginTop': '10px'}}/>
                <Box m={1}>
                <Paper className={classes.paper} elevation={0}>
                    {!user._id && !loading.init &&
                    <Card elevation={1}>
                        <CardContent>
                            <Box>
                                <FormControl variant="outlined"
                                             fullWidth={true}>
                                    <InputLabel id="role-select-filled-label">{t('user.role')}</InputLabel>
                                    <Select
                                        native
                                        labelId="role-select-filled-label"
                                        label={t('user.role')}
                                        name="role"
                                        value={user.role}
                                        onChange={handleChangeInviteTicket}>
                                        <option value="STAFF">{t('user.roles.STAFF')}</option>
                                        <option value="RIDER">{t('user.roles.RIDER')}</option>
                                        <option value="ADMIN">{t('user.roles.ADMIN')}</option>
                                    </Select>
                                </FormControl>
                            </Box>
                            <Box mt={2}>
                                <ThemeProvider theme={theme}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        disableElevation
                                        size="large"
                                        fullWidth={true}
                                        className={classes.button}
                                        disabled={loading.update}
                                        onClick={handleSendInvite}
                                        startIcon={<img style={{width: '32px'}} alt="LINE" src="data:image/png;base64,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" />}
                                    >
                                        {t('user.sentInvitation')}
                                    </Button>
                                </ThemeProvider>
                            </Box>
                        </CardContent>
                    </Card>
                    }
                    {user._id && !loading.init &&
                    <Card elevation={1}>
                        <CardContent>
                            <Box
                                display="flex"
                                alignItems="center"
                                justifyContent="center"
                            >
                                <Avatar alt="profile" src={`${process.env.REACT_APP_CDN_BASE_URL}/public/user/${user._id}`} className={classes.large} style={{
                                    border: '1px solid lightgray'
                                }} />
                            </Box>
                            <Box
                                display="flex"
                                alignItems="center"
                                justifyContent="center"
                                mt={1}>
                                <Typography variant="h6" component="div">
                                    {user.displayName}
                                </Typography>
                            </Box>
                            {user.role === 'OWNER' &&
                                <Box display="flex"
                                     alignItems="center"
                                     justifyContent="center" mt={2}>
                                    <Chip label={t('user.roles.OWNER')} />
                                </Box>
                            }
                            {user.role !== 'OWNER' &&
                            <>
                                <Box mt={4}>
                                    <FormControl variant="outlined"
                                                 fullWidth={true}>
                                        <InputLabel id="role-select-filled-label">{t('user.role')}</InputLabel>
                                        <Select
                                            native
                                            labelId="role-select-filled-label"
                                            label={t('user.role')}
                                            name="role"
                                            value={user.role}
                                            onChange={handleChange}>
                                            <option value="STAFF">{t('user.roles.STAFF')}</option>
                                            <option value="RIDER">{t('user.roles.RIDER')}</option>
                                            <option value="ADMIN">{t('user.roles.ADMIN')}</option>
                                        </Select>
                                    </FormControl>
                                </Box>
                                <div className={classes.actionControl}>
                                    <Grid container spacing={0}>
                                        <Grid item xs={12} sm={6} className={classes.itemCancel}>
                                            <Box className={classes.boxRight}>
                                                {user._id &&
                                                <Button variant="contained"
                                                        color="secondary"
                                                        size="large"
                                                        disableElevation
                                                        fullWidth={matches}
                                                        disabled={loading.update}
                                                        startIcon={<DeleteIcon/>}
                                                        onClick={(e) => handleClickOpen(e)}>
                                                    {t('common.delete')}
                                                </Button>
                                                }
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} sm={6} className={classes.itemSave}>
                                            <Box className={classes.boxLeft}>
                                                <Button variant="contained"
                                                        color="primary"
                                                        size="large"
                                                        disableElevation
                                                        fullWidth={matches}
                                                        disabled={loading.update}
                                                        startIcon={<SaveIcon/>}
                                                        onClick={(e) => handleSave(e)}>
                                                    {t('common.save')}
                                                </Button>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </div>
                            </>
                            }
                        </CardContent>
                    </Card>
                    }
                </Paper>
                </Box>
            </form>
            <Dialog
                open={open}
                keepMounted
                onClose={handleClose}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle id="alert-dialog-slide-title">{t('common.message.confirm')}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                        {t('common.message.confirmDelete')}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained"
                            onClick={handleClose}
                            fullWidth={matches}
                            size="large"
                            disableElevation>
                        {t('common.cancel')}
                    </Button>
                    <Button variant="contained"
                            color="secondary"
                            size="large"
                            disableElevation
                            fullWidth={matches}
                            startIcon={<DeleteForeverIcon />}
                            onClick={(e) => handleDelete(e)}>
                        {t('common.delete')}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}